(function() {
    'use strict';


    PatientAgreementsController.$inject = ['$scope', 'AgreementsWorkflowService', 'InvitationService', 'ipmConstants', 'PatientService', '$window' , '$state'];

    function PatientAgreementsController($scope, AgreementsWorkflowService, InvitationService, constants, PatientService, $window, $state) {
        var vm = this; //jshint ignore:line
        vm.PatientAgreementResponse = null;
        vm.patientAgreements = [];
        vm.pageSize = 7;
        vm.totalItems = 0;
        vm.page = 1;
        vm.predicate = 'createdDate';
        vm.reverse =  true;
        vm.isSendingInvitation = false;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.downloadAll = downloadAll;
        vm.isShowDownloadAll = isShowDownloadAll;
        vm.isAgreementSignedAllByAPI = isAgreementSignedAllByAPI;
        vm.goToPatientAgreement = goToPatientAgreement;
        vm.resendPatientAgreement = resendPatientAgreement;
        vm.isDisableLaunchResendPatientAgreement = isDisableLaunchResendPatientAgreement;
        vm.isDisableAddNewPatientAgreement = isDisableAddNewPatientAgreement;

        init();

        function init() {
            vm.pageableAP = {
                page: 1,
                size: vm.pageSize,
                totalItems: 0
            };
            vm.loadAll();
        }

        function loadAll() {
            var pageable = {
                page: vm.pageableAP.page > 0 ? vm.pageableAP.page - 1 : vm.pageableAP.page,
                size: vm.pageSize,
                sort: sort()
            };
            if (vm.patientId) {
                AgreementsWorkflowService.findAllByPatientId(vm.patientId, pageable).then(function (response) {
                    vm.pageableAP.totalItems = response && response.totalItems ? response.totalItems : 0;
                    vm.patientAgreements = response ? response.data : [];
                });
            }
        }

        function sort() {
            return [vm.predicate + ',' + (vm.reverse ? 'desc' : 'asc')];
        }

        function loadPage (page) {
            vm.page = page;
            vm.loadAll();
        }

        function downloadAll() {
            if (vm.patientId) {
                AgreementsWorkflowService.downloadAllAgreementsByPatientId(vm.patientId).then(function (response) {
                });
            }
        }

        function isShowDownloadAll(patientAgreements) {
            if (!patientAgreements || !patientAgreements.length) {
                return false
            }
            return patientAgreements.some(function (item) {
                return item && String(item.status).toUpperCase().trim() === 'COMPLETE' && String(item.createdSource).toUpperCase().trim() !== 'EXTERNAL';
            });
        }

        function isAgreementSignedAllByAPI(patientAgreements) {
            return patientAgreements && patientAgreements.length > 0 && patientAgreements[0].agreementSignedAllByAPI;
        }

        function isDisableLaunchResendPatientAgreement(pa) {
            return (pa != null && pa.status != null && pa.status === 'COMPLETE' || vm.isBiller)
        }

        function resendPatientAgreement(pa){
            if (vm.isSendingInvitation === true || isDisableLaunchResendPatientAgreement(pa) || !pa.id) {
                return;
            }
            vm.isSendingInvitation = true;
            InvitationService.resendPatientAgreement(pa.id).then(function (res) {
                vm.isSendingInvitation = false;
                if (res.statusCode === 200) {
                    InvitationService.openResendInvitationDialog();
                } else if (res.statusCode === 400 && res.message === 'missing_email_phone') {
                    InvitationService.openWarningMissingEmailPhone();
                }
            });
        }

        function goToPatientAgreement($event, patientAgreement) {
            $event.preventDefault();
            if (!vm.patientId || !patientAgreement.id || patientAgreement.status === 'COMPLETE' || patientAgreement.status === 'CANCEL') {
                return;
            }
            PatientService.getPatientByIdAndAutoLogin(vm.patientId, null).then(function (res) {
                $window.localStorage.setItem(constants.PATIENT_AGREEMENT_ID, patientAgreement.id);
                $window.localStorage.setItem(constants.PASS_RESTRICTION, true);
                $window.localStorage.setItem(constants.LAUNCH_FROM, constants.PATIENT_AGREEMENT);
                $state.go('home');
            });
        }

        function isDisableAddNewPatientAgreement() {
            return vm.isBiller;
        }
    }

    angular.module('ipmApp').component('patientAgreements', {
        bindings: {
            patientId: '<',
            isBiller: '<'
        },
        templateUrl: 'app/patient/agreements/patient-agreements.html',
        controller: PatientAgreementsController,
        controllerAs: 'vm',
        resolve: {
            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                $translatePartialLoader.addPart('patient');
                $translatePartialLoader.addPart('agreements');
                return $translate.refresh();
            }]
        }
    })
})();
